<template>
    <div>
        <vx-card>
            <div slot="no-body" class="tabs-container px-6 pt-6">
                <div class="tab-text">
                    <div class="vx-row">
                        <div class="vx-col md:w-2/3 w-full mt-2">
                            <vs-input
                                v-validate="'required|min:3|max:255'"
                                :data-vv-as="'Tên gói phần mềm'"
                                data-vv-validate-on="blur"
                                name="packageName"
                                label="Tên gói"
                                v-model="packageOrg.packageName"
                                autocomplete="off"
                                class="w-full"/>
                            <span class="text-danger text-sm">{{
                                    errors.first("packageName")
                                }}</span>
                        </div>
                        <div class="vx-col md:w-1/3 w-full mt-2">
                            <vs-input
                                v-validate="'required|numeric'"
                                :data-vv-name="'price'"
                                data-vv-validate-on="blur"
                                :data-vv-as="'Giá tiền'"
                                name="price"
                                label="Giá tiền(VND)"
                                v-model="packageOrg.price"
                                autocomplete="off"
                                class="w-full"/>
                            <span class="text-danger text-sm">{{
                                    errors.first("price")
                                }}</span>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col md:w-1/3 w-full mt-2">
                            <label class="vs-input--label">Thời gian lưu trữ</label>
                            <v-select class="" v-model="selectedTimeStorages" :clearable="false"
                                      :options="timeStorages">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }} </span>
                            </v-select>
                        </div>
                        <div class="vx-col md:w-1/3 w-full mt-2">
                            <vs-input
                                v-validate="'required|numeric'"
                                :data-vv-name="'totalCamera'"
                                data-vv-validate-on="blur"
                                :data-vv-as="'Số camera'"
                                name="totalCamera"
                                label="Số camera"
                                v-model="packageOrg.totalCamera"
                                autocomplete="off"
                                class="w-full"/>
                            <span class="text-danger text-sm">{{
                                    errors.first("totalCamera")
                                }}</span>
                        </div>
                        <div class="vx-col md:w-1/3 w-full mt-2">
                            <vs-input
                                v-validate="'required|numeric'"
                                :data-vv-name="'totalCameraAI'"
                                data-vv-validate-on="blur"
                                :data-vv-as="'Số camera sử dụng AI'"
                                name="totalCameraAI"
                                label="Số camera sử dụng AI"
                                v-model="packageOrg.totalCameraAI"
                                autocomplete="off"
                                class="w-full"/>
                            <span class="text-danger text-sm">{{
                                    errors.first("totalCameraAI")
                                }}</span>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col md:w-1/3 w-full mt-2">
                            <vs-input
                                v-validate="'required|numeric'"
                                :data-vv-name="'s3_quota'"
                                data-vv-validate-on="blur"
                                :data-vv-as="'Data lưu trữ'"
                                name="s3_quota"
                                label="Data lưu trữ(GB)"
                                v-model="packageOrg.s3_quota"
                                autocomplete="off"
                                class="w-full"/>
                            <span class="text-danger text-sm">{{
                                    errors.first("s3_quota")
                                }}</span>
                        </div>
                        <div class="vx-col md:w-1/3 w-full mt-2">
                            <label class="vs-input--label">Độ phân giải</label>
                            <v-select class="" v-model="selectedProfile" :clearable="false"
                                      :options="profiles">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }} </span>
                            </v-select>
                        </div>
                        <div class="vx-col md:w-1/3 w-full mt-2">
                            <label class="vs-input--label">Thời hạn gói</label>
                            <v-select class="" v-model="selectedPackageOrganization" :clearable="false"
                                      :options="packageOrganization">
                                <span slot="no-options"> {{ $t('menuOrganization.noOption') }} </span>
                            </v-select>
                        </div>

                    </div>
                    <div class="vx-row">
                        <div class="vx-col md:w-2/3 w-full mt-2">
                            <label class="vs-input--label">Sử dụng chức năng AI</label>
                            <multiselect
                                v-model="permissionFunctionsAI"
                                :options="permissionList"
                                :searchable="false"
                                :multiple="true"
                                :close-on-select="false"
                                :allow-empty="true"
                                placeholder="Chọn chức năng"
                                label="label"
                                track-by="value"
                            >
                            </multiselect>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                                <vs-button class="ml-auto mt-2" @click="saveChanges"
                                           :disabled="!validateForm">{{
                                        `${isUpdate ?
                                            'Cập nhật' : 'Tạo mới'}`
                                    }}
                                </vs-button>
                                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">Quay
                                    lại
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import vSelect from 'vue-select'
import Multiselect from 'vue-multiselect';

export default {
    components: {
        vSelect,
        Multiselect
    },
    data() {
        return {
            isUpdate: false,
            id: null,
            packageOrgId: null,
            packageOrg: {
                packageName: null,
                // gia tien
                price: null,
                // thoi gian luu tru (ngay)
                timeStorage: 3,
                // so camera
                totalCamera: null,
                // so camera ai
                totalCameraAI: null,
                //Data luu tru
                s3_quota: null,
                //profile
                profile: 1,
                permissionFunctions: [],
                //Thoi han goi
                packageDuration: 3
            },
            profiles: [
                {value: 1, label: "360P"},
                {value: 2, label: "480P"},
                {value: 3, label: "640p"},
                {value: 8, label: "720p"},
                {value: 9, label: "1080p"}
            ],
            packageOrganization: [
                {value: 3, label: "3 ngày"},
                {value: 7, label: "7 ngày"},
                {value: 15, label: "15 ngày"},
                {value: 30, label: "30 ngày"}
            ],
            timeStorages: [
                {value: 3, label: "3 ngày"},
                {value: 7, label: "7 ngày"},
                {value: 15, label: "15 ngày"},
                {value: 30, label: "30 ngày"}
            ],
            permissionList:[],
            permissionFunctionsAI: [],
        };
    },
    computed: {
        selectedProfile: {
            get() {
                return {
                    label: this.getProfileString(this.packageOrg.profile),
                    value: this.packageOrg.profile
                }
            },
            set(obj) {
                this.packageOrg.profile = obj.value
            }
        },
        selectedPackageOrganization: {
            get() {
                return {
                    label: this.getPackageOrganizationString(this.packageOrg.packageDuration),
                    value: this.packageOrg.packageDuration
                }
            },
            set(obj) {
                this.packageOrg.packageDuration = obj.value
            }
        },
        selectedTimeStorages: {
            get() {
                return {
                    label: this.getTimeStoragesString(this.packageOrg.timeStorage),
                    value: this.packageOrg.timeStorage
                }
            },
            set(obj) {
                this.packageOrg.timeStorage = obj.value
            }
        },
        validateForm() {
            return !this.errors.any();
        },
    },
    async created() {
        await this.getPermissionAI();
        this.packageOrgId = this.$route.query.id;
        if (this.packageOrgId) {
            this.findById();
        }
    },
    methods: {
        findById(){
            this.$vs.loading();
            this.$crm.get('/organization-package/find-by-id/' + this.packageOrgId).then((response) => {
                this.$vs.loading.close();
                this.packageOrg = response.data;
                this.packageOrg.permissionFunctions.map(x => {
                    let packageOrgFunction = this.permissionList.find(p => p.value == x.id);
                    this.permissionFunctionsAI.push(packageOrgFunction);
                })
                this.isUpdate = true;
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        getPermissionAI() {
            return new Promise(resolve => {
                this.$vs.loading();
                this.$crm.post('/permission-function/find-all').then((response) => {
                    this.permissionList = response.data.map(x => {
                        let obj = {value: x.id, label: x.functionAlias};
                        return obj;
                    })
                    resolve(true);
                    this.$vs.loading.close();
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        getProfileString(id) {
            let profile = this.profiles.find(x => x.value === id);
            return (profile && profile.label) || 'Chưa xác định';
        },
        getPackageOrganizationString(id) {
            let packageOrg = this.packageOrganization.find(x => x.value === id);
            return (packageOrg && packageOrg.label) || 'Chưa xác định';
        },
        getTimeStoragesString(id) {
            let timeStore = this.timeStorages.find(x => x.value === id);
            return (timeStore && timeStore.label) || 'Chưa xác định';
        },
        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;
            this.packageOrg.permissionFunctions = this.permissionFunctionsAI.map(x => x.value);
            let path = this.isUpdate ? ('/organization-package/update/' + this.packageOrgId) : '/organization-package/create';
            let params = this.packageOrg;
            this.$vs.loading();
            this.$crm.post(path, params).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? 'Cập nhật' : 'Thêm'} gói phần mềm thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.$router.push('/admin/organization-package');
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
    }
};
</script>
